import * as Sentry from '@sentry/react';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import {
    IMPACT_FILTER_REQUESTED,
    IMPACT_FILTER_ZOOM_CHANGED_REQUESTED,
} from './constants';
import { impactFilterSucceeded, impactFilterFailed } from './actions';
import { getLitters } from '../api/';
import { parseClientError } from '../api/utils';
import { getSelectedZoom, getSelectedDimension } from './selectors';
import { getUserData } from '../screens/auth/selectors';
import { logException } from '../logger';

function* filterLitters() {
    const zoom = yield select(getSelectedZoom);
    const dimension = yield select(getSelectedDimension);
    try {
        const params = {};

        yield put(
            impactFilterSucceeded({
                impactLitters: [],
                hasMoreData: false,
            }),
        );
        if (dimension.right < 0) dimension.right = Math.abs(dimension.right);
        if (dimension.left > 0) dimension.left = -dimension.left;

        const litters = yield call(getLitters, {
            ...params,
            zoom,
            ...dimension,
        });
        yield put(
            impactFilterSucceeded({
                impactLitters: litters.data,
                hasMoreData: false,
            }),
        );
    } catch (e) {
        Sentry.captureException(e);
        const userData = yield select(getUserData);
        logException(e, { ...userData });
        const error = parseClientError(e);
        const message = error && error.message ? error.message : error;
        yield put(impactFilterFailed(message));
    }
}

export default function*() {
    yield all([yield takeLatest(IMPACT_FILTER_REQUESTED, filterLitters)]);
    yield all([
        yield takeLatest(IMPACT_FILTER_ZOOM_CHANGED_REQUESTED, filterLitters),
    ]);
}
